<script setup lang="ts">
import {ref} from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";

const props = defineProps<{
	type?: 'phone' | 'email'
}>()

const emit = defineEmits<{
	(e: 'on-call'): void,
	(e: 'on-email'): void,
	(e: 'on-copy'): void,
}>()

const $tooltip = ref<typeof AppTooltip | null>(null)

const onCopy = () => {
	emit('on-copy')
	$tooltip.value?.showByClick()
}
</script>

<template>
	<div class="email-phone-options-dropdown">
		<div
			v-if="props.type === 'phone'"
			class="email-phone-options-dropdown__item"
			@click="emit('on-call')"
		>
			<app-icon
				name="phone"
				width="14px"
				color="#979797"
			/>
			<div class="email-phone-options-dropdown__item-text">
				{{ $t('contact_call') }}
			</div>
		</div>
		<div
			v-else
			class="email-phone-options-dropdown__item"
			@click="emit('on-email')"
		>
			<app-icon
				name="envelope"
				width="14px"
				color="#979797"
			/>
			<div class="email-phone-options-dropdown__item-text">
				{{ $t('contact_write') }}
			</div>
		</div>
		<app-tooltip
			ref="$tooltip"
			:text="$t(props.type === 'email' ? 'email_copied' : 'phone_copied')"
			position="bottom"
			show-by-activator-click
		>
			<template #activator>
				<div
					class="email-phone-options-dropdown__item"
					@click="onCopy"
				>
					<app-icon
						name="copy"
						width="14px"
						color="#979797"
					/>
					<div class="email-phone-options-dropdown__item-text">
						{{ $t('ui_copy') }}
					</div>
				</div>
			</template>
		</app-tooltip>
	</div>
</template>

<style scoped lang="scss">
.email-phone-options-dropdown {
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	background: #fff;
	padding: 2px 4px;

	&__item {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 5px 8px;
		border-radius: 8px;
		box-sizing: border-box;

		&:hover {
			background-color: #F2F2F2;
			cursor: pointer;
		}

		&-text {
			font-size: 14px;
			line-height: 18px;
		}
	}
}
</style>
